type LoadScriptOptions = {
  id: string
  src: string
  crossOrigin?: string
}

const scriptPromises: Record<string, Promise<void> | undefined> = {}

export const loadScript = ({ id, src, crossOrigin }: LoadScriptOptions): Promise<void> => {
  if (typeof window === 'undefined') return Promise.resolve()

  if (scriptPromises[id]) return scriptPromises[id]

  scriptPromises[id] = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(id) as HTMLScriptElement | null

    if (existingScript?.dataset.loaded === 'true') {
      resolve()
      return
    }

    const script = existingScript || document.createElement('script')
    script.id = id
    script.src = src
    script.async = true
    script.defer = true

    if (crossOrigin) {
      script.crossOrigin = crossOrigin
    }

    script.onload = () => {
      script.dataset.loaded = 'true'
      resolve()
    }

    script.onerror = (event) => {
      delete scriptPromises[id]
      reject(event)
    }

    if (!existingScript) {
      document.body.appendChild(script)
    }
  })

  return scriptPromises[id]
}
